import { endsWith } from "@grindex-common/helpers/domManipulation";

export const baseLink = {
	getBaseLinkWithoutSegments: function (tabs) {
		var currentUrl = window.location.pathname;
		const segments = tabs.split(",");
		var i;

		if (endsWith(currentUrl, "/")) {
			currentUrl = currentUrl.slice(0, -1);
		}

		for (i = 0; i < segments.length; i++) {
			if (endsWith(currentUrl, "/" + segments[i])) {
				const removeLastPartRegex = new RegExp("/[^/]*$");
				currentUrl = currentUrl.replace(removeLastPartRegex, "/");
			}
		}
		return currentUrl;
	},
};
